import {Component, OnInit, Inject, HostListener, DOCUMENT} from '@angular/core';

const scrollEnabled = false;

@Component({
    selector: 'app-scroll-helper',
    templateUrl: './scroll.component.html',
    styleUrls: ['./scroll.component.scss'],
    standalone: false
})
export class Scroll implements OnInit {
  windowScrolled: boolean;

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  @HostListener('window:scroll')
  onWindowScroll() {

    if (
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop > 100
    ) {
      this.windowScrolled = true;
    } else if (
      (this.windowScrolled && window.pageYOffset) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }

  }

  static toTop() {
    if (scrollEnabled) {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 8);
        }
      })();
    }
  }

  ngOnInit() {
  }
}
